import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICreateOfferToSubDealerRequest, ICreateOfferToSubDealerResponse } from '../models/models'

export class ExcelToOfferApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'excel/myoffer',
      requesterInfo,
    })
  }

  public async excelToOffer(request: ICreateOfferToSubDealerRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
